import { Action } from 'redux';
import styled from 'styled-components';
import { DropdownOptions as OriginalDropdownOptions } from '../../../turn-portfolio/TurnList/PortfolioListFilters/Shared/DropdownOptions';
import { DropdownWrapper as OriginalDropdownWrapper } from '../../../turn-portfolio/TurnList/PortfolioListFilters/Shared/DropdownWrapper';
import MinMaxDropdownOption, { MinMaxFilter } from './MinMaxDropdownOption';

interface FilterDropdownProps {
  min: number;
  max: number;
  minPossibleValue: number;
  maxPossibleValue: number;
  valueChangeAction: (filter: MinMaxFilter) => Action;
  fontColor: string;
  testId: string;
  isPricePrefix?: boolean;
  initialMin?: number;
  initialMax?: number;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  min,
  max,
  minPossibleValue,
  maxPossibleValue,
  valueChangeAction,
  fontColor,
  testId,
  ...props
}) => {
  return (
    <DropdownWrapper data-testid={testId}>
      <DropdownOptions forExtendedDropdown={true}>
        <MinMaxDropdownOption
          min={min}
          max={max}
          minPossibleValue={minPossibleValue}
          maxPossibleValue={maxPossibleValue}
          valueChangeAction={valueChangeAction}
          fontColor={fontColor}
          isPricePrefix={props.isPricePrefix}
          initialMin={props.initialMin}
          initialMax={props.initialMax}
        />
      </DropdownOptions>
    </DropdownWrapper>
  );
};

const DropdownWrapper = styled(OriginalDropdownWrapper)`
  background-color: transparent;
`;

const DropdownOptions = styled(OriginalDropdownOptions)`
  background-color: transparent;
`;

export default FilterDropdown;
